"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillStatus = void 0;
var Failure_1 = require("./Failure");
var SkillStatus = /** @class */ (function (_super) {
    __extends(SkillStatus, _super);
    function SkillStatus() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "SkillStatus";
        _this.health = function () {
            _this.push(function (_) { return "health"; });
        };
        _this.running = function () {
            _this.push(function (_) { return "running"; });
        };
        _this.pending = function () {
            _this.push(function (_) { return "pending"; });
        };
        _this.failures = function (config) { return _this.push(function (registry) {
            var entity = new Failure_1.Failure();
            config(entity);
            return "failures { " + entity.render(registry) + " }";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return SkillStatus;
}(Array));
exports.SkillStatus = SkillStatus;
//# sourceMappingURL=SkillStatus.js.map